import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router, UrlTree } from '@angular/router';
import { FULL_ROUTES } from '@shared/constants';
import { UserType } from '@shared/enums/user-type.enum';
import { Observable } from 'rxjs';
import { AuthService } from '../../shared/services/auth.service';

@Injectable({ providedIn: 'root' })
export class UserTypeGuard implements CanActivate, CanLoad {

    constructor(private authService: AuthService, private router: Router) { }

    private hasAccess(requiredUserTypes: UserType[]): boolean {
        const userType = this.authService.getUserType();
        return userType !== null && requiredUserTypes.includes(userType);
    }

    private checkAccess(requiredUserTypes: UserType[]): boolean | UrlTree {
        try {
            if (this.authService.isTokenExpired()) {
                return this.router.createUrlTree([FULL_ROUTES.LOGIN]);
            }

            if (!requiredUserTypes || !this.hasAccess(requiredUserTypes)) {
                console.log('No user type access');
                return this.router.createUrlTree(['/auth/access']);
            }

            return true;
        } catch (error) {
            return this.router.createUrlTree([FULL_ROUTES.LOGIN]);
        }
    }

    canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> {
        const requiredUserTypes = route.data['userTypes'] as UserType[];
        return this.checkAccess(requiredUserTypes);
    }

    canLoad(route: Route): boolean | UrlTree | Observable<boolean | UrlTree> {
        const requiredUserTypes = route.data?.['userTypes'] as UserType[];
        return this.checkAccess(requiredUserTypes);
    }
}
